module.exports = __webpack_public_path__ + "img/icon_pharmacy.7e8747e3.svg";